export default __webpack_public_path__ + "static/media/zm.76c93fc6.svg";